import { HTTP } from './common'

import {GET_CLIENT, GET_CLIENTS, UPDATE_CLIENT} from '@/store/types/index'

export const Clients = {
  [GET_CLIENT] (userId) {
    let urlString = `clients/${userId}`
    return HTTP.get(urlString)
      .then(response => {
        return response.data
      })
  },
  [GET_CLIENTS] () {
    let urlString = `clients`
    return HTTP.get(urlString)
      .then(response => {
        return response.data
      })
  },
  [UPDATE_CLIENT] (client, userId) {
    let urlString = `clients/${userId}/update/`
    return HTTP.put(urlString, client)
      .then(response => {
        return response.data
      })
  },
}
